import type React from "react";

import useModal from "../../../../hooks/useModal";
import CreateLevelContent from "./CreateLevelContent";

const CreateLevelModalButton: React.FC = () => {
  const {openModal, closeModal, Modal} = useModal();

  return (
    <>
      <div
        onClick={openModal}
        className="w-[200px] cursor-pointer bg-gradient-to-b from-black/50 to-indigo-900/50 flex items-center justify-center rounded-lg shadow-sm transition duration-300 hover:from-black/90 hover:to-indigo-900/90 text-center"
      >
        <span className="text-white text-6xl font-bold">+</span>
      </div>
      <Modal>
        <CreateLevelContent closeModal={closeModal} />
      </Modal>
    </>
  );
};

export default CreateLevelModalButton;
